import { render, staticRenderFns } from "./SelectGrammarCard.vue?vue&type=template&id=6de99438&"
import script from "./SelectGrammarCard.vue?vue&type=script&lang=js&"
export * from "./SelectGrammarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports